import es from "./es"

export default{
  messages: {es}
}